<div class="cm-landing-fixed-width">
	<form [formGroup]=form
		*ngIf="form">
		<h2>CropManage Irrigation Recommendation Calculator</h2>

		<h4>Crop Information</h4>
		<mat-form-field
			*ngIf="commodityTypes" 
			appearance="fill"
			class="mat-form-field--one-line mat-form-field--short">

			<mat-label>{{'Commodity' | translate }}</mat-label>

			<mat-select required
				formControlName="CommodityTypeId">

				<mat-option *ngFor="let commodityType of commodityTypes"
					[value]="commodityType.Id">
					{{commodityType.Name | translate}}
				</mat-option>

			</mat-select>

			<mat-error *ngIf="f.CommodityTypeId.invalid && (f.CommodityTypeId.dirty || f.CommodityTypeId.touched)">
				{{'Cannot be empty. Please select an option.' | translate }}
			</mat-error>

		</mat-form-field>

		<mat-form-field
			*ngIf="cropTypes && cropTypes.length > 0" 
			appearance="fill"
			class="mat-form-field--one-line mat-form-field--short">

			<mat-label>{{'CropType' | translate }}</mat-label>

			<mat-select required
				formControlName="CropTypeId">

				<mat-option *ngFor="let cropType of cropTypes"
					[value]="cropType.Id">
					{{ cropType.Name }}
				</mat-option>

			</mat-select>

			<mat-error *ngIf="f.CropTypeId.invalid && (f.CropTypeId.dirty || f.CropTypeId.touched)">
				{{'Cannot be empty. Please select an option.' | translate }}
			</mat-error>

		</mat-form-field>

		<mat-form-field *ngIf="isTree"
			appearance="fill"
			class="mat-form-field--one-line mat-form-field--short">

			<mat-label>{{'Age of Crop' | translate }}</mat-label>

			<mat-select
				required
				formControlName="AgeOfCrop">

				<mat-option *ngFor="let ageOfCropOption of ageOfCropOptions"
					[value]="ageOfCropOption.key">
					{{ ageOfCropOption.value }}
				</mat-option>

			</mat-select>

			<mat-error *ngIf="f.AgeOfCrop.invalid && (f.AgeOfCrop.dirty || f.AgeOfCrop.touched)">

				{{'Age of crop is required' | translate }}
			</mat-error>

		</mat-form-field>

		<div class="instruction-container">
			<h4>Crop Season Dates</h4>
			<p>Enter the start and end dates of the crop's growing season.</p>
		
			<ul>
				<li>Start and end dates must be less than 366 days apart.</li>
				<li>Dates must not be older than two years ago.</li>
			</ul>
		</div>
		<div>
			<mat-form-field appearance="fill"
				class='bk-mat-date-field bk-mat-date-field--first'>
				<mat-label>{{ 'Start Date' | translate }}</mat-label>
				<input matInput [matDatepicker]="wetDatePicker"
					formControlName="WetDate"
					required
					[min]="wetDateRange.minDate"
					[max]="wetDateRange.maxDate">
				<mat-datepicker-toggle matSuffix [for]="wetDatePicker"></mat-datepicker-toggle>
				<mat-datepicker #wetDatePicker></mat-datepicker>
				<mat-error *ngIf="f.WetDate.invalid && (f.WetDate.dirty || f.WetDate.touched)">
					{{'Planting Event Date Error Text' | translate }}
				</mat-error>
			</mat-form-field>

			<mat-form-field appearance="fill"
				class='bk-mat-date-field'>
				<mat-label>{{ 'End Date' | translate }}</mat-label>
				<input matInput [matDatepicker]="harvestDatePicker"
					formControlName="HarvestDate"
					required
					[min]="harvestDateRange.minDate"
					[max]="harvestDateRange.maxDate">
				<mat-datepicker-toggle matSuffix [for]="harvestDatePicker"></mat-datepicker-toggle>
				<mat-datepicker #harvestDatePicker></mat-datepicker>
				<mat-error *ngIf="f.HarvestDate.invalid && (f.HarvestDate.dirty || f.HarvestDate.touched)">
					{{'Planting Event Date Error Text' | translate }}
				</mat-error>
			</mat-form-field>
		</div>

		<h4>
			Irrigation Event Dates
		</h4>

		<mat-form-field appearance="fill"
			class='bk-mat-date-field bk-mat-date-field--first'
			style="width: 250px;">
			<mat-label>{{ 'Previous Irrigation Date' | translate }}</mat-label>
			<input matInput [matDatepicker]="previousDatePicker"
				formControlName="PreviousDate"
				required
				[min]="previousDateRange.minDate"
				[max]="previousDateRange.maxDate">
			<mat-datepicker-toggle matSuffix [for]="previousDatePicker"></mat-datepicker-toggle>
			<mat-datepicker #previousDatePicker></mat-datepicker>
			<mat-error *ngIf="f.PreviousDate.invalid && (f.PreviousDate.dirty || f.PreviousDate.touched)">
				{{'Event Date Error Text' | translate }}
			</mat-error>
			<mat-hint align="start">
				Date of last irrigation before Event Date. Used to calculate
				crop water use (ET) and rainfall.
			</mat-hint>
		</mat-form-field>

		<mat-form-field appearance="fill"
			class='bk-mat-date-field'>
			<mat-label>{{ 'Event Date' | translate }}</mat-label>
			<input matInput [matDatepicker]="eventDatePicker"
				formControlName="EventDate"
				required
				[min]="eventDateRange.minDate"
				[max]="eventDateRange.maxDate">
			<mat-datepicker-toggle matSuffix [for]="eventDatePicker"></mat-datepicker-toggle>
			<mat-datepicker #eventDatePicker></mat-datepicker>
			<mat-hint align="start">
				Event Date must be longer later than 30 days after the previous date.
			</mat-hint>
			<mat-error *ngIf="f.EventDate.invalid && (f.EventDate.dirty || f.EventDate.touched)">
				{{'Event Date Error Text' | translate }}
			</mat-error>
		</mat-form-field>

		<div *ngIf="isEventDateFuture"
            class="bk-modal__warning-section">
			Future recommendations are calculated with historical ET data and zero rainfall.
		</div>

		<h4>
			Irrigation Method
		</h4>

		<mat-form-field  appearance="fill"
			class="bk-mat-date-field--first">

			<mat-label>
				{{ 'Irrigation Method' | translate }}
			</mat-label>
			<mat-select required
				formControlName="IrrigationMethodId">

				<mat-option *ngFor="let option of irrigationMethodOptions"
					[value]="option.Id">
					{{ option.Text | translate }}
				</mat-option>

			</mat-select>

		</mat-form-field>

		<mat-form-field appearance="fill"
			class="bk-mat-date-field bk-mat-date-field--first"
			*ngIf="this.f.IrrigationMethodId.value">
			<mat-label>
				{{ 'Application Rate' | translate }}
			</mat-label>
			<input matInput
				type="number"
				required
				formControlName="ApplicationRate" />
	
			<span matSuffix>
				<i class="fa fa-calculator bk-clickable"
					*ngIf="this.f.IrrigationMethodId.valid"
					matTooltip="{{ 'Application Rate Calculator' | translate }}"
					(click)="openApplicationCalculator(this.f.IrrigationMethodId.value)">
				</i>
			</span>

		</mat-form-field>

		<mat-form-field appearance="fill"
			*ngIf="this.f.IrrigationMethodId.value"
			class="bk-mat-date-field">
			<mat-label>
				{{ 'Distribution Uniformity' | translate }}
			</mat-label>
			<input matInput
				type="number"
				step="0.01"
				name="DistributionUniformity"
				formControlName="DistributionUniformity"/>
			<span matSuffix class="mat-form-field-suffix--padded">
				%
			</span>
			<mat-hint align="start">
				<strong>{{ 'Application uniformity of irrigation system. 100% = perfect uniformity.' | translate }}</strong>
			</mat-hint>
		</mat-form-field>

		<h4>Location</h4>
		<p>
			Click the location of your planting on the map. CropManage will use your location to get accurate weather and
			soil data used for ET calculation.
		</p>
		
		<agm-map *ngIf="weatherStations && weatherStations.length > 0"
			#map
			(mapClick)="clickMap($event)"
			(mapReady)="mapReady($event)"
			[zoom]="10"
			[mapTypeId]="'hybrid'"
			[fullscreenControl]="true">

			<agm-marker *ngIf="f.Latitude.value && f.Longitude.value"
				[iconUrl]="'../assets/images/icons/map_marker-planting.png'"
				[latitude]="f.Latitude.value"
				[longitude]="f.Longitude.value">
			</agm-marker>

			<map-control #mapControl></map-control>
		</agm-map>

		<p *ngIf="weatherStations && f.WeatherStationId.value">

			<strong>Nearest Weather Station: </strong>{{ weatherStations[0].Name }}
			<br>
			<strong>Distance: </strong> {{ weatherStations[0].Distance * 0.621371 | number:'1.2-2' }} miles
			<br>
		</p>

		<br>
		<br>

		<ng-container *ngIf="singleCallResult">
			<div class="ir-calculator__summary-row">
				<div class="ir-calculator__summary-col ir-calculator__summary-col--table">
					<table class="ir-calculator__summary-table" cellpadding="10">
						<tbody>
							<tr>
								<td>
									Recommended Amount (Hours) <mat-icon *ngIf="exceedsMaxPAW"
									matTooltip="{{ 'Recommendation capped due to excessive number of days passed since previous irrigation' | translate }}">
									warning</mat-icon>
								</td>
								<td *ngIf="hours + minutes > 0">
									<span *ngIf="hours > 0">
										{{ hours }} hour{{ hours > 1 ? 's' : '' }}
									</span>
									<span *ngIf="hours > 0 && minutes > 0"> </span>
									<span *ngIf="minutes > 0">
										{{ minutes }} minute{{ minutes > 1 ? 's' : '' }}
									</span>
								</td>
								<td *ngIf="hours + minutes === 0">
									0 hours
								</td>
							</tr>
							<tr>
								<td>
									Recommended Amount (Inches)
								</td>
								<td>
									{{ recommendation | number:'1.2-2' }} in.
								</td>
							</tr>
							<tr>
								<td>
									Days Since Last Saturation
									<mat-icon class="ir-calculator__info-icon material-symbols-outlined"
										matTooltip="The date of your last irrigation or significant rainfall event. CropManage assumes full soil saturation occurred at that time."
										[matTooltipClass]="'cm-verbose-tooltip'">
										info
									</mat-icon>
								</td>
								<td>
									{{ singleCallResult.DaysSinceLastIrrigation }} days
								</td>
							</tr>
							<tr>
								<td>
									Total Reference ET
								</td>
								<td>
									{{ totalReferenceET | number:'1.2-2' }} in.
								</td>
							</tr>
							<tr>
								<td>
									Total Rainfall
								</td>
								<td>
									{{ singleCallResult.TotalPrecipitation | number:'1.2-2' }} in.
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="ir-calculator__summary-col ir-calculator__summary-col--chart"
				*ngIf="singleCallEvapRecords.length">
				<div class="bk-chart ir-calculator__evap-chart" #singleCallEvapChart></div>
			</div>
			</div>

			<br>
			<button mat-button
				type="button"
				[disabled]="!form.valid || isSaving"
				class="bk-button bk-button--medium"
				(click)="calculate()">
				<span *ngIf="!isSaving">Adjust &amp; recalculate</span>
				<span *ngIf="isSaving">Calculating</span>
				<img class='bk-button__loader' *ngIf='isSaving' src='/assets/images/loader-20px.gif'/>
			</button>
		</ng-container>

		<div class="registration-prompt" *ngIf="singleCallResult">
			<p class="registration-prompt__summary">
				Registered users get more accurate results &mdash; applied water history, soil water balance tracking,
				and deficit irrigation planning are included.
			</p>
			<a routerLink="/register" class="registration-prompt__cta">Create a free account &rarr;</a>
		</div>

		<br>
		<mat-form-field class="hp"
			appearance="fill">
			<mat-label>{{ 'Company' | translate }}</mat-label>
			<input matInput
				type="text"
				tabindex="-1"
				autocomplete="off"
				aria-hidden="true"
				formControlName="Company">
		</mat-form-field>
		<button mat-button
			*ngIf="!singleCallResult"
			[disabled]="!form.valid || isSaving"
			class="bk-button bk-button--medium"
			(click)="calculate()">

			{{ (isSaving ? 'Calculating' : 'Calculate') | translate }}
			<img class='bk-button__loader' *ngIf='isSaving' src='/assets/images/loader-20px.gif'/>
		</button>
		<br>
		<br>
	</form>
</div>